import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {AbstractControl} from '@angular/forms';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import {map, startWith} from 'rxjs/operators';
import {Observable} from 'rxjs';
import {VSensorService} from '../../v-sensor-shared/v-sensor.service';

@Component({
    selector: 'app-location-autocomplete-input',
    templateUrl: './location-autocomplete-input.component.html',
    styleUrls: ['./location-autocomplete-input.component.css']
})
export class LocationAutocompleteInputComponent implements OnInit {

    @Input() locationControl: AbstractControl;
    @Input() readOnly: boolean;
    @Input() index: any;
    @ViewChild('trigger') autocompleteTrigger: MatAutocompleteTrigger;
    filteredProjectLocations: Observable<any[]>;
    readonly projectLocations;

    constructor(private vSensorService: VSensorService) {
        this.projectLocations = this.vSensorService.projectLocations;
    }

    ngOnInit() {
        this.initFilteredProjectLocations();
    }

    updateParamGroupFromKeyboardInput(userInput) {
        if ('string' !== typeof userInput) {       // case when option is selected by keyboard, which will be handled by mat-autocomplete
            return;
        }
        if (!userInput || userInput === '') {
            this.locationControl.setValue('');
            return;
        }
        const targetLocation = this.projectLocations.find(
            (location) => {
                if (!location.name) {
                    return false;
                }
                return location.name.toLowerCase() === userInput.toLowerCase();
            }
        );
        if (targetLocation) {
            this.locationControl.setValue(targetLocation.id);
        }
    }

    mapLocationNameFromId(id): any {
        const location = this.mapLocationFromId(id);
        return location ? location.name : '';
    }

    private mapLocationFromId(id): any {
        if (!this.projectLocations) {
            return undefined;
        }
        return this.projectLocations.find(
            (location) => {
                if (!location.id) {
                    return false;
                }
                return parseInt(location.id, 10) === parseInt(id, 10);
            }
        );
    }

    private initFilteredProjectLocations() {
        this.filteredProjectLocations = this.locationControl.valueChanges.pipe(
            startWith(''),
            map((inputValue) => {
                if (!this.projectLocations) {
                    return [];
                }
                if (!inputValue || inputValue === '') {
                    return this.projectLocations;
                }
                if ('string' !== typeof inputValue) {
                    return [];
                }
                return this.projectLocations.filter(
                    (location) => location.name ?
                        location.name.toLowerCase().trim().includes(inputValue.toLowerCase().trim())
                        : false
                );
            })
        );
    }

}
